import React, { useState } from 'react';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import InfoSection from '../InfoSection';
import { Button } from '../ButtonElements';
import {
  HeroContainer,
  HeroBg,
  VideoBg,
  HeroContent,
  HeroH1,
  HeroP,
  HeroBtnWrapper,
  ArrowForward,
  ArrowRight,
} from '../HeroSection/HeroElements';
import { homeObjOne, homeObjTwo } from './DigitalData';
import digitalVideo from '../../videos/Virtual_Tours.mp4';

const DigitalPage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hover, setHover] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <HeroContainer id="digital-home">
        <HeroBg>
          <VideoBg playsInline autoPlay loop muted src={digitalVideo} type="video/mp4" />
        </HeroBg>
        <HeroContent>
          <HeroH1>
            Digital & Virtual Tours
            <br />
            Bring your space to life online
          </HeroH1>
          <HeroP>
            Wiry creates 360° virtual views and digital experiences so your business or space
            stands out and reaches more customers.
          </HeroP>
          <HeroBtnWrapper>
            <Button
              to="on-demand"
              smooth
              duration={500}
              spy
              offset={-80}
              primary
              dark
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
            >
              Learn More {hover ? <ArrowForward /> : <ArrowRight />}
            </Button>
          </HeroBtnWrapper>
        </HeroContent>
      </HeroContainer>
      <InfoSection {...homeObjOne} />
      <InfoSection {...homeObjTwo} />
      <Footer />
    </>
  );
};

export default DigitalPage;
